<div [className]="!user?.firstName ? 'p-0.5 rounded-lg bg-red-400 dark:bg-red-500' : ''">
    <div [ngClass]="getCssClass('card')" class="grid grid-cols-1 bg-card rounded-lg">
        <div class="flex items-center w-full" [ngClass]="getCssClass('p')">
            <div *ngIf="!user?.firstName"
                 [ngClass]="getCssClass('img')"
                 class="sm:mr-4 mr-2 rounded-full flex items-center justify-center overflow-hidden uppercase text-3xl font-bold leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                ?
            </div>
            <div *ngIf="user?.firstName && !user?.avatar"
                 [ngClass]="getCssClass('img')"
                 class="sm:mr-4 mr-2 rounded-full flex items-center justify-center overflow-hidden uppercase text-3xl font-bold leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                {{user?.firstName?.charAt(0)}}
            </div>

            <img
                [ngClass]="getCssClass('img')"
                class="sm:mr-4 mr-2 rounded-full" alt="Card cover" *ngIf="user?.firstName && user?.avatar;" [src]="user?.avatar">

            <div *ngIf="user?.firstName"
                 class="hidden sm:flex flex-col w-full gap-0">
                <div [ngClass]="getCssClass('title')" class="leading-tight w-full">{{user?.firstName}} <b>{{user?.lastName}}</b></div>

                <div *ngIf="selectedSize > 1" class="flex w-full" >
                    <mat-icon class="hidden md:flex mr-2 icon-size-5" [svgIcon]="'heroicons_solid:user-group'"></mat-icon>
                    <div [ngClass]="getCssClass('subTitle')" class="w-full"> {{ _permissionsService.getUserRolesTranslated(user)}}</div>
                </div>
            </div>

            <div *ngIf="!user?.firstName"
                 class="hidden sm:flex flex-col w-full gap-0">
                <div [ngClass]="getCssClass('title')" class="ml-5 w-full text-left text-hint">{{ 'No user selected' | transloco }}</div>
                <div class="ml-5 w-full text-sm text-left text-hint">{{ 'Please select' | transloco }}</div>
            </div>
        </div>
    </div>
</div>



